import { useTranslation } from 'react-i18next'

import { BuildingSelect } from '../../../Building'
import { Skeleton } from '../../../Skeleton'
import { CalendarRailBlock } from '../CalendarRailBlock'

import { QA_NAME_CALENDAR_RAIL_BUILDING } from './CalendarRailBuilding.constants'
import { useCalendarRailBuildings } from './CalendarRailBuilding.hooks'
import {
  getCalendarRailBuildingOption,
  toCalendarRailBuilding,
} from './CalendarRailBuilding.utils'

import * as styles from './CalendarRailBuilding.module.css'

function CalendarRailBuilding({ building, onChange }) {
  const { t } = useTranslation()

  const { getBuildings, hasBuildings, isListFailed, isLoading } =
    useCalendarRailBuildings()

  function handleClearBuilding() {
    onChange({ building: null })
  }

  function handleSelectBuilding(option) {
    onChange({ building: toCalendarRailBuilding(option) })
  }

  return (
    <CalendarRailBlock
      title={t('Calendar.RailObjectKey')}
      warning={isListFailed ? t('Calendar.RailListLoadFailedTooltipKey') : null}
    >
      {isLoading ? (
        <Skeleton className={styles.skeleton} />
      ) : (
        <BuildingSelect
          controlProps={{
            contentProps: {
              inputProps: { placeholder: t('Calendar.RailObjectAllKey') },
            },
          }}
          disabled={!hasBuildings}
          getData={getBuildings}
          qaName={QA_NAME_CALENDAR_RAIL_BUILDING}
          value={getCalendarRailBuildingOption(building)}
          onClear={handleClearBuilding}
          onSelectItem={handleSelectBuilding}
        />
      )}
    </CalendarRailBlock>
  )
}

export default CalendarRailBuilding
